module.exports = __webpack_public_path__ + "94d2722cc2a8b0eb883edc5b5f5debfd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/amy.png
// module id = 541
// module chunks = 0